import { Component, inject, input, output } from '@angular/core';
import { CoverageItemComponent } from '@webapp/core/ui/components/coverage-item/coverage-item.component';
import { RecommendedBadgeComponent } from '@webapp/core/ui/components/recommended-badge/recommended-badge.component';
import { ButtonComponent } from '@webapp/ui';

import { QuoterStoreService } from '../../../store/quoter-store.service';

import { ICoverage } from '@webapp/payments';
import { CoveragePriceComponent } from '@webapp/core/ui/components/coverage-price/coverage-price.component';

@Component({
  selector: 'app-quoter-coverage-card',
  standalone: true,
  imports: [
    ButtonComponent,
    CoveragePriceComponent,
    CoverageItemComponent,
    RecommendedBadgeComponent,
  ],
  templateUrl: './quoter-coverage-card.component.html',
  styleUrl: './quoter-coverage-card.component.scss',
})
export class QuoterCoverageCardComponent {
  private quoterStateService = inject(QuoterStoreService);
  readonly quoterState = this.quoterStateService.state.asReadonly();
  coverage = input.required<ICoverage>();
  coverageSelected = output<ICoverage>();
  

  setCoverage(coverage: ICoverage) {
    this.coverageSelected.emit(coverage);
  }


}
